import React from "react";
import "./ContactMap.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const ContactMap = () => {
  return (
    <section className="oglitz-contact-map">
      <div className="oglitz-contact-map-container">
        {/* HEADER */}
        <div className="oglitz-contact-map-header">
          <span className="oglitz-map-badge">Our Locations</span>
          <h2>
            India & <span>Dubai</span>
          </h2>
          <p>
            Strategically located offices enabling seamless collaboration and
            global delivery.
          </p>
        </div>

        {/* MAP GRID */}
        <div className="oglitz-map-grid">
          {/* INDIA MAP */}
          <div className="oglitz-map-card">
            <div className="oglitz-map-float">HQ</div>
            <div className="oglitz-map-title">
              <LocationOnIcon />
              <span>India (Headquarters)</span>
            </div>

            <iframe
              title="Oglitz India Office"
              src="https://www.google.com/maps?q=Kanpur+Uttar+Pradesh+India&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* DUBAI MAP */}
          <div className="oglitz-map-card">
            <div className="oglitz-map-float">HQ</div>
            <div className="oglitz-map-title">
              <LocationOnIcon />
              <span>Dubai, UAE</span>
            </div>

            <iframe
              title="Oglitz Dubai Office"
              src="https://www.google.com/maps?q=Dubai+UAE&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMap;
